import {
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  Paper,
  Container,
} from "@mui/material";
import "./index.css";

const SoftwareFeatures = ({ title, features, subTiltle }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        p: 4,
        backgroundColor: "transparent",
        color: "white",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{ color: "#DADFEF" }}
        >
          {title}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "#DADFEF" }}>
          {subTiltle}
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {features.map((industry, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Paper
                elevation={3}
                className="software-feature-card"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  padding: 3,
                  borderRadius: 2,
                  color: "#B6BFE080",
                  cursor: "pointer",
                  borderColor: "#DD93E2 !important",
                  border: "3px solid",
                  //   "&:hover": { backgroundColor: "#C64BCE" },
                }}
              >
                <Typography style={{ color: "white" }}>
                  {industry.title}
                </Typography>
                <Typography style={{ color: "white" }}>
                  {" "}
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    style={{ width: "40px" }}
                  />
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default SoftwareFeatures;
